import{kebabCase as t}from"../../utils/StringUtils.mjs";function i(i,r){return t(void 0===r?i:`${i}-${r}`)}export{i as genEleId};
